import React from 'react';
import PublicLayout, { PageHero } from '../../components/PublicLayout';

export default function LegalPage({ titre, eyebrow, contenu }) {
  return (
    <PublicLayout>
      <PageHero eyebrow={eyebrow || 'Information légale'} title={titre}/>
      <section className="max-w-3xl mx-auto px-6 py-14 prose prose-slate">
        {contenu}
      </section>
    </PublicLayout>
  );
}

export function MentionsLegales() {
  return <LegalPage titre="Mentions légales" contenu={
    <>
      <h2>Éditeur du site</h2>
      <p>
        <strong>BFI Groupe</strong><br/>
        Société Anonyme à directoire au capital de 50 000 000,00 €<br/>
        Siège social : RTE CHABAN, 79180 CHAURAY, France<br/>
        Inscrite au RCS de Niort sous le numéro 401 380 472<br/>
        SIREN : 401 380 472 — SIRET (siège) : 401 380 472 00019<br/>
        N° de TVA intracommunautaire : FR15401380472<br/>
        Code NAF / APE : 65.12Z (Autres assurances)<br/>
        Identifiant LEI : 969500MO80IIJ5R0YR54<br/>
        Date d’immatriculation : 16/06/1995<br/>
        Email : contact@bfigroupefr.com
      </p>
      <h2>Direction de la publication</h2>
      <p>Le directeur de la publication est le Président du Directoire de BFI Groupe.</p>
      <h2>Hébergement</h2>
      <p>Le site est hébergé sur une infrastructure aux standards bancaires européens, conforme aux normes de sécurité et de confidentialité en vigueur.</p>
      <h2>Autorités de tutelle</h2>
      <p>BFI Groupe est un établissement contrôlé par l’Autorité de Contrôle Prudentiel et de Résolution (ACPR), 4 place de Budapest — CS 92459 — 75436 Paris Cedex 09, ainsi que par l’Autorité des Marchés Financiers (AMF), 17 place de la Bourse — 75002 Paris.</p>
      <h2>Propriété intellectuelle</h2>
      <p>L’ensemble des contenus présents sur ce site (textes, graphismes, logos, images, iconographies) est la propriété exclusive de BFI Groupe. Toute reproduction, représentation ou diffusion, totale ou partielle, sans autorisation écrite préalable est strictement interdite.</p>
    </>
  }/>;
}

export function CGU() {
  return <LegalPage titre="Conditions Générales d’Utilisation" contenu={
    <>
      <p>Les présentes Conditions Générales d’Utilisation (CGU) régissent l’utilisation des services en ligne de <strong>BFI Groupe</strong> (RCS Niort 401 380 472), en complément des conventions de compte signées par chaque client.</p>
      <h2>1. Objet</h2>
      <p>Les CGU ont pour objet de définir les modalités d’accès et d’utilisation des services proposés par BFI Groupe via son site internet et ses applications.</p>
      <h2>2. Accès aux services</h2>
      <p>L’accès aux services en ligne est soumis à l’identification du client par email + mot de passe + code de vérification à 6 chiffres reçu par email à chaque connexion.</p>
      <h2>3. Responsabilité du client</h2>
      <p>Le client est responsable de la confidentialité de ses identifiants. Toute opération réalisée après authentification est réputée être effectuée par le client. En cas de perte ou de vol de ses identifiants, le client doit contacter BFI Groupe sans délai.</p>
      <h2>4. Disponibilité du service</h2>
      <p>BFI Groupe s’efforce d’assurer la disponibilité de ses services 24h/24 et 7j/7. Toutefois, des interruptions peuvent survenir pour maintenance ou en cas de force majeure.</p>
      <h2>5. Propriété intellectuelle</h2>
      <p>L’ensemble du site est la propriété exclusive de BFI Groupe. Toute reproduction est interdite sans autorisation écrite préalable.</p>
      <h2>6. Loi applicable</h2>
      <p>Les présentes CGU sont régies par le droit français. Tout litige relèvera de la compétence exclusive des tribunaux français.</p>
    </>
  }/>;
}

export function Confidentialite() {
  return <LegalPage titre="Politique de confidentialité" contenu={
    <>
      <p>BFI Groupe (RCS Niort 401 380 472, siège social : RTE CHABAN, 79180 CHAURAY) respecte le Règlement Général sur la Protection des Données (RGPD) et la Loi Informatique et Libertés.</p>
      <h2>Responsable de traitement</h2>
      <p>BFI Groupe — RTE CHABAN, 79180 CHAURAY, France</p>
      <h2>Données collectées</h2>
      <p>Identité, coordonnées, données bancaires, données de connexion, justificatifs réglementaires (KYC / LCB-FT).</p>
      <h2>Finalités</h2>
      <p>Exécution du contrat bancaire, lutte anti-blanchiment (LCB-FT), sécurité des paiements, amélioration des services, opérations marketing avec votre consentement.</p>
      <h2>Bases légales</h2>
      <p>Exécution du contrat (article 6.1.b RGPD), respect d’une obligation légale (article 6.1.c), intérêt légitime (article 6.1.f), consentement explicite pour le marketing (article 6.1.a).</p>
      <h2>Vos droits</h2>
      <p>Vous disposez d’un droit d’accès, de rectification, d’effacement, d’opposition, de limitation et de portabilité. Pour exercer ces droits, écrivez au délégué à la protection des données : dpo@bfigroupefr.com.</p>
      <h2>Conservation des données</h2>
      <p>Les données bancaires sont conservées 5 ans après la clôture du compte conformément au Code monétaire et financier.</p>
    </>
  }/>;
}

export function CookiesPage() {
  return <LegalPage titre="Gestion des cookies" contenu={
    <>
      <p>BFI Groupe (RCS Niort 401 380 472) utilise différents types de cookies. Vous pouvez à tout moment modifier vos préférences via le bandeau cookies en bas de page.</p>
      <h2>Cookies nécessaires</h2>
      <p>Indispensables au fonctionnement du site (sécurité, gestion de session, code de vérification). Ces cookies ne nécessitent pas votre consentement préalable.</p>
      <h2>Cookies analytiques</h2>
      <p>Permettent de mesurer la fréquentation et d’améliorer l’expérience utilisateur. Données entièrement anonymisées.</p>
      <h2>Cookies marketing</h2>
      <p>Permettent de personnaliser les contenus et publicités. Soumis à votre consentement explicite.</p>
      <h2>Durée de conservation</h2>
      <p>Les cookies sont conservés 13 mois maximum conformément aux recommandations de la CNIL.</p>
    </>
  }/>;
}

export function RGPD() {
  return <LegalPage titre="Données personnelles & RGPD" contenu={
    <>
      <p>BFI Groupe (RCS Niort 401 380 472, RTE CHABAN, 79180 CHAURAY) est responsable du traitement des données personnelles. Pour exercer vos droits ou nous contacter sur ces sujets : <strong>dpo@bfigroupefr.com</strong></p>
      <h2>Délégué à la protection des données (DPO)</h2>
      <p>BFI Groupe a désigné un Délégué à la Protection des Données joignable à l’adresse : dpo@bfigroupefr.com</p>
      <h2>Conservation</h2>
      <p>Les données bancaires sont conservées 5 ans après la clôture du compte conformément au Code monétaire et financier. Les données de prospection sont conservées 3 ans à compter du dernier contact.</p>
      <h2>Transferts hors Union européenne</h2>
      <p>Aucun transfert de données personnelles n’est effectué hors de l’Union européenne sans garanties appropriées (clauses contractuelles types, décisions d’adéquation).</p>
      <h2>Réclamation CNIL</h2>
      <p>Vous pouvez à tout moment introduire une réclamation auprès de la Commission Nationale de l’Informatique et des Libertés (CNIL), 3 place de Fontenoy, TSA 80715, 75334 Paris Cedex 07.</p>
    </>
  }/>;
}

export function PlanDuSite() {
  const Lk = ({ to, children }) => <a href={to} className="text-blue-700 hover:underline block py-1">{children}</a>;
  return <LegalPage titre="Plan du site" contenu={
    <div className="grid md:grid-cols-2 gap-6">
      <div><h3>Particuliers</h3><Lk to="/comptes">Comptes & épargne</Lk><Lk to="/cartes">Cartes</Lk><Lk to="/credits">Crédits</Lk><Lk to="/assurances">Assurances</Lk><Lk to="/bourse">Bourse</Lk></div>
      <div><h3>Aide</h3><Lk to="/aide">Centre d’aide</Lk><Lk to="/a-propos">À propos</Lk><Lk to="/connexion">Connexion</Lk><Lk to="/inscription">Ouvrir un compte</Lk></div>
    </div>
  }/>;
}
